import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings";
import {SectionDescription} from "components/misc/Typography";
import { ReactComponent as PhoneIcon} from "feather-icons/dist/icons/phone.svg";
import { ReactComponent as MailIcon} from "feather-icons/dist/icons/mail.svg";
import { ReactComponent as MapPinIcon } from "feather-icons/dist/icons/map-pin.svg";

const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)`text-primary-500`
const Subheading = tw(SubheadingBase)`text-center mb-3`
const Description = tw(SectionDescription)`mx-auto text-center text-primary-500`

const ContactSection = tw.div`flex flex-wrap justify-center lg:max-w-6xl mx-auto mt-4`
const ContactCards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-4xl mx-auto`
const Card = tw.div`mt-12 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center px-4`

const QRSection = tw.div`mt-16 w-full`
const QRCards = tw.div`flex flex-wrap justify-center gap-8 lg:gap-16`
const QRCard = tw.div`flex flex-col items-center`

const CardImage = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`w-48 h-48 bg-contain bg-center bg-no-repeat rounded-lg border-2 border-gray-200 shadow-lg`}
`

const ContactCardIcon = styled.div`
  ${tw`w-16 h-16 bg-primary-500 text-white rounded-full flex items-center justify-center mb-4`}
  svg {
    ${tw`w-8 h-8`}
  }
`

const CardContent = styled.div`
  ${tw`flex flex-col items-center text-center`}
  .title {
    ${tw`text-xl font-semibold text-gray-900 mb-2`}
  }
  .content {
    ${tw`text-gray-600 leading-relaxed`}
  }
`

const QRCardContent = styled.div`
  ${tw`flex flex-col items-center text-center mt-4`}
  .title {
    ${tw`text-xl font-semibold text-gray-900 mb-2`}
  }
  .description {
    ${tw`text-gray-600 text-sm`}
  }
`

export default ({
                  heading = "Get In Touch",
                  subheading = "Contact Us",
                  description = "We're here to help bridge the gap between your business and Chinese suppliers. Reach out to us through any of the following channels, and our team will respond promptly to discuss your sourcing needs.",
                  contactCards = [
                    {
                      icon: MailIcon,
                      title: "Email",
                      content: "admin@ihomelondon.co.uk\nWe typically respond within 24 hours"
                    }
                  ],
                }) => {
  return (
      <Container>
        <ContentWithPaddingXl>
          <HeadingContainer>
            {subheading && <Subheading>{subheading}</Subheading>}
          </HeadingContainer>

          <ContactSection>
            <ContactCards>
              {contactCards.map((card, index) => (
                  <Card key={index}>
                    <ContactCardIcon>
                      <card.icon />
                    </ContactCardIcon>
                    <CardContent>
                      <div className="content">
                        {card.content.split('\n').map((line, lineIndex) => (
                            <div key={lineIndex}>{line}</div>
                        ))}
                      </div>
                    </CardContent>
                  </Card>
              ))}
            </ContactCards>

            <QRSection>
              <Heading tw="text-center mb-8">Connect With Us</Heading>
            </QRSection>
          </ContactSection>
        </ContentWithPaddingXl>
      </Container>
  );
};